import React, { useEffect } from 'react';
import styles from './styles.module.css';

export default function DropBackShadow({
  onClick = () => {},
  className = '',
  hideOverflow = false,
}) {
  return (
    <div className={`${styles.container} ${className}`} onClick={onClick} id="dropShadow"></div>
  );
}
